import { ListeTable } from '@mairistem/liste';
import _ from 'lodash';
import React from 'react';

import { RegieContext } from '@/contexts';

type PrelevementsListeTableHeaderProps = {
  [key: string]: any;
};

const PrelevementsListeTableHeader = (props: PrelevementsListeTableHeaderProps) => {
  const { ...rest } = props;

  const { regies, selectedRegie } = React.useContext(RegieContext);
  // Si 1 seul logiciel facturier, on masque la colonne
  const hideSourceColumn =
    _.size(_.find(regies, { identifiant: selectedRegie })?.logicielsFacturier) <= 1;

  return (
    <>
      <ListeTable.Column {...rest} name="numero" verticalAlign="middle" style={{ width: 175 }}>
        N° de facture
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="datePrelevement"
        verticalAlign="middle"
        style={{ width: 120 }}
      >
        Date de
        <br />
        prélèvement
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="montant"
        style={{ width: 130 }}
        verticalAlign="middle"
        textAlign="right"
      >
        Montant
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="cycle" verticalAlign="middle">
        Cycle de facturation
      </ListeTable.Column>
      {!hideSourceColumn && (
        <ListeTable.Column {...rest} name="source" style={{ width: 90 }} verticalAlign="middle">
          App
        </ListeTable.Column>
      )}
      <ListeTable.Column
        {...rest}
        name="titulaireComptePreleve"
        verticalAlign="middle"
        style={{ width: 300 }}
      >
        Titulaire du compte
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="compteBancairePreleve"
        verticalAlign="middle"
        style={{ width: 350 }}
      >
        Compte bancaire
      </ListeTable.Column>
    </>
  );
};

export default PrelevementsListeTableHeader;
